import * as io from 'io-ts';

export type GetFraudAlloyRequest = io.TypeOf<typeof GetFraudAlloyRequest>;
export const GetFraudAlloyRequest = io.type({});

export type GetFraudAlloyResponse = io.TypeOf<typeof GetFraudAlloyResponse>;
export const GetFraudAlloyResponse = io.type({
  journey_token: io.string,
  journey_application_token: io.string,
  journey_sdk_key: io.string,
  origin: io.string,
});

export type FraudAlloyInitResponse = io.TypeOf<typeof FraudAlloyInitResponse>;
export const FraudAlloyInitResponse = io.type({
  neuroIdSiteId: io.string,
  neuroUserId: io.string,
  iovationBlackboxId: io.string,
});

export type IDUploadJourneyResponse = io.TypeOf<typeof IDUploadJourneyResponse>;
export const IDUploadJourneyResponse = io.type({
  journey_application_status: io.union([
    io.literal('Approved'),
    io.literal('Denied'),
  ]),
});
